// 7 Themes for Zion AG Church
export const THEMES = {
  navy: {
    name: 'Navy & Gold',
    emoji: '🔵',
    desc: 'Current — Deep Navy Blue with Gold',
    preview: ['#070f22', '#c9a84c', '#f9f5ee'],
    vars: {
      '--bg-deep': '#070f22',
      '--bg-dark': '#0d1b3e',
      '--bg-mid': '#162550',
      '--bg-accent': '#1e3370',
      '--primary': '#c9a84c',
      '--primary-light': '#e8c97a',
      '--primary-dark': '#8b6914',
      '--text': '#f9f5ee',
      '--text-muted': '#c8bfa8',
      '--card-bg': 'rgba(13,27,62,0.85)',
      '--card-border': 'rgba(201,168,76,0.2)',
      '--section-alt': '#0d1b3e',
      '--event-band': 'linear-gradient(135deg,#b22222 0%,#8b6914 100%)',
      '--footer-bg': '#040a16',
      '--footer-border': '#c9a84c',
    }
  },
  maroon: {
    name: 'Maroon & Gold',
    emoji: '🔴',
    desc: 'Deep Maroon — Blood of Christ',
    preview: ['#0f0203', '#c9a84c', '#f5ede0'],
    vars: {
      '--bg-deep': '#0f0203',
      '--bg-dark': '#1c0406',
      '--bg-mid': '#2a0508',
      '--bg-accent': '#3d0a10',
      '--primary': '#c9a84c',
      '--primary-light': '#e8c97a',
      '--primary-dark': '#8b6508',
      '--text': '#f5ede0',
      '--text-muted': '#c8b090',
      '--card-bg': 'rgba(61,10,16,0.85)',
      '--card-border': 'rgba(201,168,76,0.2)',
      '--section-alt': '#150305',
      '--event-band': 'linear-gradient(135deg,#6b1520 0%,#8b6508 100%)',
      '--footer-bg': '#0a0102',
      '--footer-border': '#c9a84c',
    }
  },
  forest: {
    name: 'Forest Green & Gold',
    emoji: '🟢',
    desc: 'Nature & Life — Ooty Hills',
    preview: ['#0a1a0f', '#7cc47a', '#e8f5e0'],
    vars: {
      '--bg-deep': '#0a1a0f',
      '--bg-dark': '#0d2412',
      '--bg-mid': '#143318',
      '--bg-accent': '#1e4a22',
      '--primary': '#7cc47a',
      '--primary-light': '#a8dca6',
      '--primary-dark': '#3d8c3a',
      '--text': '#e8f5e0',
      '--text-muted': '#b0d4a8',
      '--card-bg': 'rgba(20,51,24,0.85)',
      '--card-border': 'rgba(124,196,122,0.2)',
      '--section-alt': '#0d2412',
      '--event-band': 'linear-gradient(135deg,#2d6b2b 0%,#3d8c3a 100%)',
      '--footer-bg': '#060f08',
      '--footer-border': '#7cc47a',
    }
  },
  purple: {
    name: 'Royal Purple & Gold',
    emoji: '🟣',
    desc: 'Royalty & Majesty of God',
    preview: ['#0e0818', '#b89af0', '#ede8f8'],
    vars: {
      '--bg-deep': '#0e0818',
      '--bg-dark': '#160d2a',
      '--bg-mid': '#1e1040',
      '--bg-accent': '#2d1a5a',
      '--primary': '#b89af0',
      '--primary-light': '#d4c4f8',
      '--primary-dark': '#7c52c8',
      '--text': '#ede8f8',
      '--text-muted': '#c4b8e8',
      '--card-bg': 'rgba(45,26,90,0.85)',
      '--card-border': 'rgba(184,154,240,0.2)',
      '--section-alt': '#130a22',
      '--event-band': 'linear-gradient(135deg,#5b21b6 0%,#7c52c8 100%)',
      '--footer-bg': '#080510',
      '--footer-border': '#b89af0',
    }
  },
  midnight: {
    name: 'Midnight Black & Gold',
    emoji: '⚫',
    desc: 'Premium Dark — Pure Elegance',
    preview: ['#080808', '#e8c877', '#f8f0dc'],
    vars: {
      '--bg-deep': '#080808',
      '--bg-dark': '#111111',
      '--bg-mid': '#1a1a1a',
      '--bg-accent': '#252525',
      '--primary': '#e8c877',
      '--primary-light': '#f5dfa0',
      '--primary-dark': '#b89030',
      '--text': '#f8f0dc',
      '--text-muted': '#d0b880',
      '--card-bg': 'rgba(30,30,30,0.95)',
      '--card-border': 'rgba(232,200,119,0.2)',
      '--section-alt': '#111111',
      '--event-band': 'linear-gradient(135deg,#333 0%,#b89030 100%)',
      '--footer-bg': '#040404',
      '--footer-border': '#e8c877',
    }
  },
  crimson: {
    name: 'Crimson & Gold',
    emoji: '❤️',
    desc: 'Bold & Passionate — Fire of God',
    preview: ['#1a0a0a', '#e88080', '#fff5f5'],
    vars: {
      '--bg-deep': '#1a0a0a',
      '--bg-dark': '#240f0f',
      '--bg-mid': '#301414',
      '--bg-accent': '#4a1a1a',
      '--primary': '#c9a84c',
      '--primary-light': '#e8c97a',
      '--primary-dark': '#8b6508',
      '--text': '#fff5f5',
      '--text-muted': '#e8c0c0',
      '--card-bg': 'rgba(74,26,26,0.85)',
      '--card-border': 'rgba(201,168,76,0.2)',
      '--section-alt': '#1f0c0c',
      '--event-band': 'linear-gradient(135deg,#8b1a1a 0%,#c9a84c 100%)',
      '--footer-bg': '#100606',
      '--footer-border': '#c9a84c',
    }
  },
  ivory: {
    name: 'Warm Ivory & Gold',
    emoji: '🟡',
    desc: 'Light & Welcoming — Pure Grace',
    preview: ['#fdf8f0', '#8b5a14', '#2c1a0a'],
    vars: {
      '--bg-deep': '#fdf8f0',
      '--bg-dark': '#f5ece0',
      '--bg-mid': '#ede3d4',
      '--bg-accent': '#e0d4c0',
      '--primary': '#8b5a14',
      '--primary-light': '#c9901c',
      '--primary-dark': '#5a3a0a',
      '--text': '#1a0e04',
      '--text-muted': '#5a3a10',
      '--card-bg': 'rgba(255,255,255,0.9)',
      '--card-border': 'rgba(139,90,20,0.2)',
      '--section-alt': '#f5ece0',
      '--event-band': 'linear-gradient(135deg,#8b1a1a 0%,#8b5a14 100%)',
      '--footer-bg': '#1a0e04',
      '--footer-border': '#8b5a14',
    }
  }
};

export const DEFAULT_THEME = 'navy';
